import axiosClient from '@/core/axiosClient'
const resource = '/api/login'

export default {
  async password (dto: any) {
    return await axiosClient.post(`${resource}/password`, { userName: dto.userName, password: 'NA' })
  }
}
